module.exports = __webpack_public_path__ + "fonts/4855fd5aa9ded62d16dab7c54c93de9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Footer/img/msamlin_logo.svg
// module id = 1288
// module chunks = 0